module.exports = __webpack_public_path__ + "static/img/1825_phase_function_Paper_PointsHejduk_Prediction.4a90de3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1825_phase_function_Paper_PointsHejduk_Prediction.png
// module id = uNuY
// module chunks = 0